import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/auth.scss';
import './styles/common.scss';
import './styles/mui.scss';
import App from './App';
import { configureAxiosSanitizer } from './utils/axiosSetup.js';

configureAxiosSanitizer();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
